import environment from '@utilities/environment';

export const getAssetsFolder = (path: string) => {
    let prefix: string = '/assets';

    if (!environment.isLocal) prefix = '/frontend/hestia/assets';

    return prefix + path;
};
